import React, { useEffect, useState } from 'react';
import { useSelector,  shallowEqual } from "react-redux";
//
import { Icon,  Header, List } from 'semantic-ui-react'

const ServicesEnabled = ({ organizationId }) => {

     const [organizationDetails, setOrganizationDetails] = useState(null);

    
    const { 
        get_organization } = useSelector(
            (state) => ({

                get_organization: state.organizations,
            }),
            shallowEqual
        );

    useEffect(() => {
        setOrganizationDetails(get_organization[organizationId])
    }, [get_organization, organizationId]);


    return (
        <>
            <Header as='h2'>
                Details of Services Enabled
            </Header>
            
    
            <List celled  size='large'>
                {organizationDetails?.services_enabled.map(item => (
                    <List.Item key={item.id}>
                        
                        
                        <span>{item?.enabled ? <Icon color='green' name='check' /> : <Icon color='red' name='close' />} </span>
                        <span style={{marginLeft: "10px"}}>{item?.name} </span>
                        <span style={{marginLeft: "10px"}}>{item?.question_sort_order? `Question Sort Order ${item?.question_sort_order}` : ''} </span>
                        </List.Item>
                ))}
            </List>

        </>
    );
};

export default ServicesEnabled;

